// Formular-Widgets der Symfony-Formulartypen aus dem CoreBundle (Form/Types,
// Behaviors/Translatable). Sie laufen im main-Entry, weil dieselben Formulare
// in EasyAdmin und spaeter im Portal vorkommen - das hier ueberlebt den Ausbau
// von EasyAdmin. Jedes Widget wird an seinem Mount-Element aktiviert; was eine
// Bibliothek oder groessere Daten braucht (Cleave, Icon-Liste), kommt als Chunk.
//
// Die Widgets kommen ohne JavaScript aus (das Markup steht in den Twig-Themes
// unter form/types/); hier wird nur nachgeruestet. EasyAdmin fuegt Formularzeilen
// dynamisch hinzu (Collections), deshalb laeuft das Mounten auch danach.
import { mount as mountTranslatable } from './translatable';

const widgets = [
  ['[data-translatable]', () => Promise.resolve({ mount: mountTranslatable })],
  ['[data-cleave]', () => import(/* webpackChunkName: "form-cleave" */ './cleave')],
  ['[data-icon-picker]', () => import(/* webpackChunkName: "form-icon-picker" */ './icon-picker')],
];

export function mountForms(root = document) {
  widgets.forEach(([selector, load]) => {
    const hosts = Array.from(root.querySelectorAll(selector)).filter((el) => !el.dataset.formWidget);
    if (!hosts.length) {
      return;
    }
    hosts.forEach((el) => { el.dataset.formWidget = 'mounted'; });
    load().then(({ mount }) => hosts.forEach((el) => mount(el)));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => mountForms());
} else {
  mountForms();
}
document.addEventListener('ea.collection.item-added', () => mountForms());
